module.exports = __webpack_public_path__ + "img/plateaux.27738cc5.jpg";